module.exports = __webpack_public_path__ + "softtech-logo.png?872f06875325484a85b677fb07fc097e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/softtech-logo.png
// module id = 813
// module chunks = 0